import { api } from "./../../config/api";
import { appendToFormData } from "../../helpers/form";

const basePath = "ExecaoJornada";

/**
 * Create
 *
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
 export const create = (options) => {
	const formData = new FormData();

	for( let key in options )
	{
		if( options.hasOwnProperty(key) )
		{
			appendToFormData(formData, key, options[key]);
		}
	}

	return api.post(basePath, formData);
};
